export default "__VITE_ASSET__TU7y5Tj8__"